module.exports = __webpack_public_path__ + "img/events.3c0d52b3.svg";